var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"device-layout"},[(!_vm.isMobile)?[_vm._t("pc")]:[_vm._t("mobile")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }